import { extractNestJsErrorMessage } from '../../../shared/api/rtk-query';
import { topManagerApi, TopManagerQuery } from './top-manager.api';

export const useTopManager = ({ year, month }: TopManagerQuery) => {
  const { currentData, isFetching, error } = topManagerApi.useGetTopManagerQuery(
    { year, month },
    { refetchOnMountOrArgChange: 60 }
  );

  return {
    collection: currentData ?? [],
    error: extractNestJsErrorMessage(error),
    isLoading: isFetching
  };
};
